import { t } from '../../../locale/texts';
import type { PpValidationResult, PrepackageSearchState } from '../../types';

export const usePrepackageValidation = (
    state: PrepackageSearchState,
    pristine: boolean,
): PpValidationResult & {
    validationErrors: Partial<Record<'departureDate' | 'returnDate' | 'returnDateAfterDeparture', string | null>>;
} => {
    const isFlexible = state.searchType === 'flexible';
    const hasEndWithoutStart = Boolean(!pristine && !isFlexible && !state.departureDate && state.returnDate);
    const returnDateAfterDeparture = Boolean(
        !isFlexible && state.departureDate && state.returnDate && state.departureDate > state.returnDate,
    );

    const invalid = {
        departureDate: !pristine && !isFlexible && !state.departureDate && !hasEndWithoutStart,
        returnDate: !pristine && !isFlexible && !state.returnDate,
        returnDateAfterDeparture: !pristine && !isFlexible && (hasEndWithoutStart || returnDateAfterDeparture),
    };

    const validationErrors = {
        departureDate: invalid.departureDate ? t('prepackage.validation.departureDate') : null,
        returnDate: invalid.returnDate ? t('prepackage.validation.returnDate') : null,
        returnDateAfterDeparture: invalid.returnDateAfterDeparture ? t('prepackage.validation.returnDateAfterDeparture') : null,
    };

    const validateState = (): boolean => {
        if (isFlexible) return true;
        return Boolean(state.departureDate) && Boolean(state.returnDate) && !returnDateAfterDeparture;
    };

    return { validateState, invalid, validationErrors };
};
